import React from "react";
import ChatComponent from "../HelpInteraction/ChatComponent";
import Success from "../Common/Success";
import chatList from "../HelpInteraction/chatList.json";
import PreventiveMeasures from "./PreventiveMeasures";
import ScanningMeasures from "./ScanningMeasures";

export interface ITimeLapse {
  scenario5Stage2Finish: () => void;
}

const TimeLapse = ({ scenario5Stage2Finish }: ITimeLapse) => {
  const [nextSlide, showNextSlide] = React.useState(1);
  const displayNextSlide = () => {
    showNextSlide(nextSlide + 1);
  };

  return nextSlide === 1 ? (
    <ChatComponent chatList={chatList[1]} displayNextSlide={displayNextSlide} />
  ) : nextSlide === 2 ? (
    <PreventiveMeasures displayNextSlide={displayNextSlide} />
  ) : nextSlide === 3 ? (
    <ScanningMeasures displayNextSlide={displayNextSlide} />
  ) : nextSlide === 4 ? (
    <Success
      displayNextSlide={displayNextSlide}
      message1={"Successfully completed"}
      message2={"preventive measures"}
    />
  ) : nextSlide === 5 ? (
    <ChatComponent chatList={chatList[2]} displayNextSlide={displayNextSlide} />
  ) : nextSlide === 6 ? (
    <>{scenario5Stage2Finish()}</>
  ) : (null);
};

export default TimeLapse;
